import React from 'react';
import { Page } from '@/types/page';

const DefaultLayout: React.FC<{ page: Page; children: React.ReactNode }> = ({ children }) => {
  return <>{children}</>;
};

export default DefaultLayout;
